import { resolveStaffModuleAccess } from './staffModulePermissions';

export const DESCARGAS_MODULE_ID = 'descargas';

/**
 * Descargas (/descargas, Ajustes): equipo interno (ADMIN/COLABORADOR/SUPER_COLABORADOR)
 * por defecto; USER_SMARTCFO solo con grant explícito del panel admin
 * (usuario, empresa o usuario×empresa). Espejo de smart_back descargas-permissions.ts.
 */
export function resolveDescargasAccess(userPerms, companyPerms, userCompanyPerms, roles) {
  return resolveStaffModuleAccess(
    DESCARGAS_MODULE_ID,
    userPerms,
    companyPerms,
    userCompanyPerms,
    roles,
  );
}
